module.exports = __webpack_public_path__ + "media/images/prev-b2a62ebfeb9f06f10b3ffb44562a61eb.svg";